/**
 * Redux reducer responsible for managing the state related to identifying news by word cloud.
 *
 * @param {Array} state - The current identified news by word cloud state.
 * @param {Object} action - The action dispatched to update the state.
 * @returns {Array} The updated identified news by word cloud state based on the action.
 */
const IdentifyNews = (state = [], action: any) => {
  switch (action.type) {
    case "IDENTIFY_NEWS_BY_WORD_CLOUD":
      return (state = action.payload);
    default:
      return state;
  }
};

export default IdentifyNews;
